
export const orderTypes = [
    "delivery",
    "pickup",
    "normal"
] satisfies ApiOrderType[];

export const getNormalizedOrderType = (orderType: string): ApiOrderType | null => {
    if (orderTypes.includes(orderType as ApiOrderType)) return orderType as ApiOrderType;
    return null;
}
